import Common from "../common";
import {localeFont} from "../utils";
//import isMobile from "ismobilejs";
//import Application from ""

/**
 * @class
 */
export default class PreloaderScene extends P3.Scene {
    constructor() {
        super();

        /**
         * @member {number}
         */
        this.loaded = 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._bar = null;

        /**
         * @member {PIXI.BitmapText}
         * @private
         */
        this._text = null;

        /**
         * @member {P3.Button}
         * @private
         */
        this._playButton = null;

        /**
         * @member {boolean}
         * @private
         */
        this._finishedLoading = false;
    }

    init() {
        super.init();

        //ensure font is loaded
        this.addChild(new PIXI.Text("", {
            fontFamily: "bangersregular"
        }));

        const assets = P3.assets;

        /*
        const g = new PIXI.Graphics();
        g.clear();
        g.beginFill(0x0);
        g.drawRect(0, 0, Common.STAGE_WIDTH, Common.STAGE_HEIGHT);
        g.endFill();
        this.addChild(g);

         */

        // if (Common.config.use_boomerang_preloader) {
        const background = new PIXI.Sprite(PIXI.Texture.WHITE);
        background.width = Common.STAGE_WIDTH;
        background.height = Common.STAGE_HEIGHT;
        background.tint = 0x882f88;
        this.addChild(background);
        //  }

        const logo = new PIXI.Sprite(assets.texture("boomerang"));
        // if (!Common.config.use_boomerang_preloader)
        //      bg.x = Common.STAGE_WIDTH * 0.5 - 10;
        ///   else
        logo.x = Common.STAGE_WIDTH * 0.5;
        logo.y = Common.STAGE_HEIGHT * 0.5 - 55;
        logo.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(logo);

        this._logo = logo;

        logo.scale.set(0.9);

        const holder = new PIXI.Container();
        holder.x = Common.STAGE_WIDTH * 0.5;
        holder.y = Common.STAGE_HEIGHT * 0.5 + 46;
        this.addChild(holder);

        this._bar = new PIXI.Container();
        this._bar.y = 90;
        this._bar.scale = new PIXI.Point(0.9, 0.9);
        this._bar.anchor = new PIXI.Point(0.5, 0.5);
        holder.addChild(this._bar);

        this._bar.fill = new PIXI.Sprite(assets.texture("preloader_fill"));
        this._bar.fill.anchor = new PIXI.Point(0.5, 0.5);

        this._bar.fill.mask = new PIXI.Graphics();
        this._bar.fill.mask.x = -this._bar.fill.texture.width * 0.5;
        this._bar.fill.mask.scale.x = 0;
        this._bar.fill.mask.beginFill(0xFF0000);
        this._bar.fill.mask.drawRect(0, -this._bar.fill.texture.height * 0.5,
            this._bar.fill.texture.width, this._bar.fill.texture.height);
        this._bar.fill.addChild(this._bar.fill.mask);

        this._bar.frame = new PIXI.Sprite(assets.texture("preloader_overlay"));
        this._bar.frame.anchor = new PIXI.Point(0.5, 0.5);

        //if (Common.config.use_boomerang_preloader) {
        this._bar.frame.x = -this._bar.fill.x / 2;

        this._bar.addChild(this._bar.fill);
        this._bar.addChild(this._bar.frame);
        //    }
        //     else {
        //        this._bar.frame.x = -260;
        ///        this._bar.addChild(this._bar.fill);
        ///        this._bar.addChild(this._bar.frame);
        //    }


        //this._createPlayButton();

        Howler.ctx && Howler.ctx.resume && Howler.ctx.resume();

        this._hand = new PIXI.Sprite(P3.assets.texture("preloader_hand"));
        this._hand.anchor.set(0.5, 1);
        this._hand.position.set(Common.STAGE_WIDTH * 0.5, -10);
        this.addChild(this._hand);
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {
        const loaded = Math.min(1, this.loaded);
        this._bar.fill.mask.scale.x += (loaded - this._bar.fill.mask.scale.x) * 0.4;

        // if (PIXI.utils.isMobile.any) {
        if (loaded >= 1 && !this._finishedLoading) {
            this._finishedLoading = true;

            const logoEnd = this._logo.y + 30;

            new P3.utils.TWEEN.Tween(this._hand, this._tweens)
                .to({y: this._logo.y - 20}, 600)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .start();

            const a1 = new P3.utils.TWEEN.Tween(this._logo, this._tweens)
                .to({y: logoEnd}, 80)
                .delay(200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.In);

            const b1 = new P3.utils.TWEEN.Tween(this._logo, this._tweens)
                .to({y: logoEnd - 30}, 280)
                .easing(P3.utils.TWEEN.Easing.Back.In);

            a1.chain(b1);
            a1.start();

            //this._bar.visible = false;//TODO
            //this._playButton.visible = true;

            /*
            const tl = new TimelineMax();
            tl.append(TweenMax.to(this._bar.scale, 0.2, {
                x: 0,
                y: 0,
                ease: Power1.easeInOut,
                onComplete: function () {
                    this._bar.visible = false;
                },
                onCompleteScope: this
            }));

            this._playButton.scale.set(0);
            tl.append(TweenMax.to(this._playButton.scale, 0.34, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function () {
                    this._playButton.visible = true;
                },
                onStartScope: this
            }));

             */
        }
        // }
    }

    /**
     * @private
     */
    _createPlayButton() {

        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_out");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.icon = P3.assets.texture("icon_play");

        this._playButton = new P3.Button(states);
        this._playButton.signals.click.once(() => this._onPlayButtonClick());
        /*P3.simpleButton("big", "play", ()=> {
        this._onPlayButtonClick();
    }, this);

         */
        this._playButton.x = Common.STAGE_WIDTH * 0.5;
        this._playButton.y = 580;

        this.addChild(this._playButton);
        this._playButton.visible = false;

        /*
         this._playButton = Common.createButton(Common.STAGE_WIDTH * 0.5, 580, "blank", ()=> {
         this._onPlayButtonClick();
         }, this, this, "PLAY", null);
         */


    }

    /**
     * @private
     */
    _onPlayButtonClick() {
        Howler.ctx && Howler.ctx.resume && Howler.ctx.resume();

        this._playButton.interactive = false;

        this.signals.next.dispatch(this);
    }
}
